import { createFileRoute, redirect } from '@tanstack/react-router';
import { featureFlags } from '@/lib/env';
import { DEVICE_ASSIGNMENT_FEATURE_FLAG } from '../../-constants/featureFlags';
export const Route = createFileRoute('/_staff/devices/_list/alerts/_alerts/')({
  beforeLoad: () => {
    // FeatureFlag OFF の間は基点 /devices/alerts に留めて ComingSoonCover を表示する。
    // to-be-assigned への redirect は公開後（ON）のみ発火させ、親レイアウトの
    // 基点ガードとの間で redirect ループにならないようにする。
    if (!featureFlags.check(DEVICE_ASSIGNMENT_FEATURE_FLAG)) {
      return;
    }
    throw redirect({
      to: '/devices/alerts/to-be-assigned'
    });
  }
});